import { fetchConfig } from '~/global';
import { lineItemPropStrings } from '~/lib/constants';
import { getFeeProducts, hasFeeProducts, isPhysicalItem } from './fee-utils-2';

export const getCartSectionInnerHTML = (html, selector) => {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};

export const getCartSectionsToRender = () => {
  const isCartPage = document.getElementById('main-cart-items');

  if (isCartPage) {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-cart-items',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-cart-footer',
      },
      {
        id: 'main-cart-status',
        section: document.getElementById('main-cart-status').dataset.id,
        selector: '.js-content-cart-status',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];
  } else {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.cart-count-bubble',
      },
    ];
  }
};

export const getCombinedProperties = (cartItem, additionalProperties) => {
  const { properties } = getCartItemProperties(cartItem);
  return { ...properties, ...additionalProperties };
};

export const getDatePickerProperties = (event) => {
  const deliveryDatePicker = event.target.closest('delivery-date-picker');
  const {
    arrivalDatePropertyKey,
    arrivalDatePropertyValue,
    shipByDatePropertyKey,
    shipByDatePropertyValue,
    arrivalDateInIsoPropertyKey,
    arrivalDateInIsoPropertyValue,
  } = deliveryDatePicker.dataset;

  return {
    [arrivalDatePropertyKey]: arrivalDatePropertyValue,
    [shipByDatePropertyKey]: shipByDatePropertyValue,
    [arrivalDateInIsoPropertyKey]: arrivalDateInIsoPropertyValue,
  };
};

export const hasPickedDate = (event) => {
  return event.target.value === 'alternate-date' || event.target.classList.contains('flatpickr-input');
};

export const updateCartLiveRegions = (line, message) => {
  const lineItemStatusElement =
    document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

  const lineItemError =
    document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
  if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

  lineItemStatusElement.setAttribute('aria-hidden', true);

  const cartStatus =
    document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
  cartStatus.setAttribute('aria-hidden', false);

  setTimeout(() => {
    cartStatus.setAttribute('aria-hidden', true);
  }, 1000);
};

export const getConnectedFeeProducts = (items, groupKey) => {
  return items.filter(
    (item) =>
      item.properties[lineItemPropStrings.groupKey] === groupKey && item.properties[lineItemPropStrings.type] === 'fee'
  );
};

export const getCartItemProperties = (cartItem) => {
  const scriptElement = cartItem.querySelector('script[data-cart-item-json]');
  const scriptParsedObj = JSON.parse(scriptElement.textContent);
  const propertiesObject = Object.fromEntries(scriptParsedObj.properties);

  for (let property in propertiesObject) {
    if (typeof propertiesObject[property] == 'string') {
      propertiesObject[property] = replaceEscapedCharacters(propertiesObject[property]);
    }
  }

  scriptParsedObj.properties = propertiesObject;

  return scriptParsedObj;
};

export const replaceEscapedCharacters = (string) => {
  const escapedCharacters = {
    '&amp;': '&',
    'amp;': '',
    '&quot;': '"',
    '&#39;': "'",
  };

  for (let character in escapedCharacters) {
    string = string.replaceAll(character, escapedCharacters[character]);
  }

  return string;
};

export const getCartObject = (container) => {
  const scriptElement = container.querySelector('script[data-cart-json]');
  const scriptParsedObj = JSON.parse(scriptElement.textContent);
  const cartObj = scriptParsedObj.cart;

  return cartObj;
};

export const cartActions = {
  update: async (body) => fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }),
  add: async (body) => fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } }),
  change: async (body) => fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }),
};

/** Legacy cleanup: remove all fee products from cart. Fee products are no longer used;
 *  surcharges are now stored as _shipping_charge property on the main product. */
export const validateFeeProducts = (cartObject, updates) => {
  const feeProducts = getFeeProducts(cartObject.items);

  feeProducts.forEach((product) => {
    updates[product.key] = 0;
  });
};

export const validatePhysicalItems = (cartObject, changes) => {
  const physicalItems = cartObject.items.filter(isPhysicalItem);

  if (physicalItems.length === 1) {
    const onlyPhysicalItem = physicalItems[0];
    const change = {};

    const addressProperties = [
      'Address',
      '_address-first-name',
      '_address-last-name',
      '_address-address',
      '_address-address1',
      '_address-address2',
      '_address-city',
      '_address-state',
      '_address-country',
      '_address-province',
      '_address-zip',
      '_address-phone',
      '_address-email'
    ];

    const hasAddressProperties = addressProperties.some((property) => onlyPhysicalItem.properties[property]);
    const currentItemProperties = Object.keys(onlyPhysicalItem.properties);

    if (hasAddressProperties) {
      change.id = onlyPhysicalItem.key;
      change.properties = {};

      currentItemProperties.forEach((property) => {
        if (!addressProperties.includes(property)) {
          change.properties[property] = onlyPhysicalItem.properties[property];
        }
      });
    }

    if (Object.keys(change).length) {
      changes.push(change);
    }
  }

  console.log('Cart Validation: Changes', changes);
};